var React = require('react');

function Pentagon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","opacity":".5","key":0},React.createElement("path",{"stroke":"#7CB0C8","strokeMiterlimit":"10","strokeWidth":"5","d":"M400-141.917L2.934 146.583 154.62 613.374h490.812l151.685-466.791L400-141.917z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0H800V760.86H0z","transform":"translate(0 -145)"})))]);
}

Pentagon.defaultProps = {"width":"583","height":"616","fill":"none","viewBox":"0 0 583 616"};

module.exports = Pentagon;

Pentagon.default = Pentagon;
